











import {ChartDataTemplate, WConfTpl, WidgetDefinition} from "@/components/widgets/WidgetFather"
import {bus} from "@/main"
import {defineComponent, reactive} from "@vue/composition-api"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {extractParams, getTitle} from "@/components/widgets/hd/hdCommon"
import {executeQuery} from "@/data/repos/query"

export function config(): WidgetDefinition {
    return {
      ...WConfTpl.KeyValue(),
      widget: "HDJobsAllocatedForMonthToDate",
      title: "Reactive Job lines allocated for month",
      params: {
      },
    }
  }

  async function dataFetcher(params: any) {
    const p = extractParams(params)
    return {
      data: await executeQuery(
        "FMS_DB",
        "jobsAllocatedInAMonth",
        {ppmRepair: 2 /* repair */, category: 0 /* category ignored for repair */, year: p.year, month: p.month}),
    }
  }

  function getChartDataConfig() {
    return reactive({
        ...ChartDataTemplate(),
        showZeroPies: "1",
      },
    )
  }

  async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
    config && (chartDataConfig.subCaption = getTitle(config.params))
  }

  export default defineComponent({
    props: {
      config: {type: Object, required: true},
    },
    components: {FusionChartWidget},
    setup(props, context) {
      context.emit("config-update", config())

      function dataplotClickCallback(label: any, val: any) {
        if (label === undefined) {
          return
        }
        const status = label === "Completed" ? 1 : 0
        const componentArgs = {...extractParams(props.config.params), ppmRepair: 2, category: 0, status}
        bus.$emit("chartPopup", {
          title: config().title + ": " + getTitle(props.config.params),
          component: () => import('@/components/drilldowns/JobsAllocatedInAMonthDrillDown.vue'),
          componentArgs,
        })
      }

      return {dataFetcher, getChartDataConfig, configChangeCallback, dataplotClickCallback}
    },
  })
